import React, { Component, use } from 'react';
import logo from '../../plugins/topbar/toyota_logo.svg'
import { login } from '../utils/login-auth.js'
import NewUserPassword from './new-user-password.jsx';
import ForgotPassword from './forgot-password.jsx';
import NewPassword from './newpassword.jsx';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      currentView: 'Login'
    };
  }


  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleLogin = async (e) => {
    e.preventDefault();
    try {
      const result = await login(this.state.username, this.state.password);
      let data = { email_varified: true }
      data.storedAt = new Date().toISOString();
      console.log(result);
      sessionStorage.setItem('SessionToken', result.Session)
      console.log(sessionStorage.getItem('SessionToken'));
      console.log('ChallemgeName',result.ChallengeName);
      if (result.ChallengeName === 'NEW_PASSWORD_REQUIRED') {
        console.log('View', this.state.currentView)
        this.setState({ currentView: 'NewUserPassword' });
        return;
      }
       sessionStorage.setItem('CognitoSession', JSON.stringify(data));
      this.props.onLogin();
    } catch (err) {
      console.error("Login failed", err);
      alert('Enter valid username and password')
    }
  };

  onChangeView = (view) => {
    this.setState({ currentView: view })
  }
  render() {
    let { currentView } = this.state;
    return (
      <div>
        <div>
          <div className='login-nav-bar'>
            <span className='nav-bar-img'><img src={logo} alt="toyota_logo" /></span>
          </div>
          {currentView === "Login" && (
            <div className='login-form'>
              <div className='login-heading'>
                <span className='login-form-heading'>Documentation Portal Login</span>
              </div>
              <form className='login-info'>
                <div>
                  <span htmlFor='username'>Username</span>
                  <input
                    type='text'
                    className='form-input-text'
                    id='username'
                    onChange={this.handleChange}
                  />
                </div>
                <div>
                  <span htmlFor='password'>Password</span>
                  <input
                    type='password'
                    className='form-input-text'
                    id='password'
                    onChange={this.handleChange}
                  />
                </div>
                <button className='login-button' onClick={this.handleLogin}>
                  Log in
                </button>
                 <span className='forgot-password'
                  onClick={() => this.onChangeView("ForgotPassword")}
                >Forgot Password ?</span> 
              </form>
            </div>
          )}
           {currentView === "NewUserPassword" && (
            <NewUserPassword
              username={this.state.username}
              onLogin={this.props.onLogin}
            />
          )
          }
         {currentView === "ForgotPassword" && (
            <ForgotPassword
              currentView={currentView}
              username={this.state.username}
              onUsernameChange={(newUsername) => this.setState({ username: newUsername })}
              onChangeView={(view) => this.setState({ currentView: view })}
            />
          )}
          {currentView === "SetNewPassword" && (
            <NewPassword
              currentView={currentView}
              username={this.state.username}
              onChangeView={(view) => this.setState({ currentView: view })}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Login;